module.exports = __webpack_public_path__ + "newsdefault2.jpg?9e43b47dc82bf79ead0e198e5e993aa2";